import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { AlertService } from '../../shared/services/alert.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse && event.body && (event.body as any).success === false) {
        // Bəzi API-lar 200 OK qaytarıb daxildə success: false göndərə bilər
        // Bu halda xətanı throw edirik ki, komponentin error bloku onu tutsun
        throw new HttpErrorResponse({
          error: event.body,
          status: 200,
          statusText: 'Logical Error',
          url: event.url || undefined
        });
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (isBrowser) {
          authService.logout();
          router.navigate(['/login']);
        }
        return throwError(() => error);
      }

      // Xəta interceptor-da tutulub alert kimi çıxmasın (istifadəçi komponentdə istəyir)
      // Amma serverlə əlaqə kəsilərsə (status 0) və ya 500 xətası olarsa burada göstərmək olar
      if (isBrowser) {
        if (error.status === 0) {
          alertService.error('Serverlə əlaqə qurulmadı. İnternet bağlantınızı yoxlayın.');
        } else if (error.status === 500) {
          alertService.error('Serverdə daxili xəta baş verdi.');
        }
      }

      return throwError(() => error);
    })
  );
};
